
import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LoadingSpinner from "@/components/common/LoadingSpinner";

interface SwapRequestLayoutProps {
  children: React.ReactNode;
  isLoading?: boolean;
  reagentId?: string;
}

const SwapRequestLayout: React.FC<SwapRequestLayoutProps> = ({ 
  children, 
  isLoading = false,
  reagentId 
}) => {
  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <div className="flex-1 flex items-center justify-center">
          <LoadingSpinner size="lg" />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <div className="container mx-auto px-4 py-8 flex-grow">
        {reagentId && (
          <div className="mb-4">
            <Link to={`/reagents/${reagentId}`} className="text-reagent-blue hover:underline inline-flex items-center">
              <ChevronLeft className="h-4 w-4 mr-1" />
              Back to Reagent
            </Link>
          </div>
        )}
        
        <div className="max-w-3xl mx-auto">
          {children}
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default SwapRequestLayout;
